/**
 * Image
 *
 * @module
 */

import { once } from 'lodash-es';

/**
 * Generate a slug. Taken from https://gist.github.com/mathewbyrne/1280286
 *
 * @param {HTMLImageElement} img
 * @param {string[]} srcs
 * @return {void}
 */
function nextFallbackSource(img, srcs)
{
    const src = srcs.shift();
    if (srcs.length) {
        img.addEventListener('error', once(() => nextFallbackSource(img, srcs)));
    }
    img.src = src;
}

/**
 * Generate a slug. Taken from https://gist.github.com/mathewbyrne/1280286
 *
 * @param {HTMLImageElement} img
 * @param {string[]} srcs
 * @return {void}
 */
export function addFallbackSources(img, srcs)
{
    if (img.naturalWidth) {
        return;
    }
    if (img.complete) {
        nextFallbackSource(img, srcs);
        return;
    }
    img.addEventListener('error', once(() => nextFallbackSource(img, srcs)));
}
